import type { Outlet } from 'modules/supplier/outletOrServiceCategory/types';
import { useVendorOutlets } from 'modules/supplier/pricelist/useVendorOutlets';
import { useMemo } from 'react';

/**
 * The vendor outlets a radio price list can price. Untyped outlets are included:
 * `type` is only set once an outlet is classified, and dropping them would hide
 * rates already entered against them.
 */
export function useRadioOutlets(vendorId: number): Outlet[] {
  const outlets = useVendorOutlets(vendorId);
  return useMemo(() => outlets.filter((outlet) => outlet.type === 'RADIO' || outlet.type === null), [outlets]);
}
